var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66663 10C8.66663 8.98748 9.48744 8.16666 10.5 8.16666C11.5125 8.16666 12.3333 8.98748 12.3333 10C12.3333 11.0125 11.5125 11.8333 10.5 11.8333C9.48744 11.8333 8.66663 11.0125 8.66663 10Z",
    fill: "#172A47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66663 4.16667C8.66663 3.15414 9.48744 2.33333 10.5 2.33333C11.5125 2.33333 12.3333 3.15414 12.3333 4.16667C12.3333 5.17919 11.5125 6 10.5 6C9.48744 6 8.66663 5.17919 8.66663 4.16667Z",
    fill: "#172A47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66663 15.8333C8.66663 14.8208 9.48744 14 10.5 14C11.5125 14 12.3333 14.8208 12.3333 15.8333C12.3333 16.8459 11.5125 17.6667 10.5 17.6667C9.48744 17.6667 8.66663 16.8459 8.66663 15.8333Z",
    fill: "#172A47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.aa04dbdeb928a63105ce43253692d48e.svg";
export { ForwardRef as ReactComponent };